module.exports = __webpack_public_path__ + "img/media_8.24c5b861.jpg";